export const indicadores = [
  {
    id: 'vinculo-acompanhamento-territorial',
    titulo: 'Componente Vínculo e Acompanhamento Territorial',
    identificador: 'componente vínculo e acompanhamento territorial',
    colunasPreview: 17,
  },
  {
    id: 'desenvolvimento-infantil',
    titulo: 'Cuidado no desenvolvimento infantil',
    identificador: 'cuidado no desenvolvimento infantil',
    colunasPreview: 16,
  },
  {
    id: 'gestantes-puerperas',
    titulo: 'Cuidado na Gestação e Puerpério',
    identificador: 'cuidado na gestação e puerpério',
    colunasPreview: 22,
  },
  {
    id: 'diabetes',
    titulo: 'Cuidado da pessoa com Diabetes',
    identificador: 'cuidado da pessoa com diabetes',
    colunasPreview: 15,
  },
  {
    id: 'hipertensao',
    titulo: 'Cuidado da pessoa com Hipertensão',
    identificador: 'cuidado da pessoa com hipertensão',
    colunasPreview: 13,
  },
  {
    id: 'pessoa-idosa',
    titulo: 'Cuidado da pessoa idosa',
    identificador: 'cuidado da pessoa idosa',
    colunasPreview: 13,
  },
  {
    id: 'saude-da-mulher',
    titulo: 'Cuidado da mulher na prevenção do câncer',
    identificador: 'cuidado da mulher na prevenção do câncer',
    colunasPreview: 17,
  },
  {
    id: 'acoes-interprofissionais',
    titulo: 'Ações Interprofissionais',
    identificador: 'ações interprofissionais',
    colunasPreview: 10,
  },
  {
    id: 'media-atendimentos-pessoa',
    titulo: 'Média de atendimentos da eMulti por pessoa',
    identificador: 'atendimentos da eMulti por pessoa',
    colunasPreview: 10,
  },
  {
    id: 'primeira-consulta-odontologica',
    titulo: 'Primeira consulta odontológica programada',
    identificador: 'primeira consulta odontológica programada',
    colunasPreview: 10,
  },
  {
    id: 'tratamento-odontologico-concluido',
    titulo: 'Tratamento Odontológico Concluído',
    identificador: 'tratamento odontológico concluído',
    colunasPreview: 10,
  },
  {
    id: 'exodontias',
    titulo: 'Exodontias',
    identificador: 'exodontias',
    colunasPreview: 10,
  },
  {
    id: 'escovacao-supervisionada',
    titulo: 'Escovação supervisionada',
    identificador: 'escovação supervisionada',
    colunasPreview: 10,
  },
  {
    id: 'procedimentos-preventivos',
    titulo: 'Procedimentos odontológicos preventivos',
    identificador: 'procedimentos odontológicos individuais preventivos',
    colunasPreview: 10,
  },
  {
    id: 'tratamento-restaurador-atraumatico',
    titulo: 'Tratamento Restaurador Atraumático',
    identificador: 'tratamento restaurador atraumático',
    colunasPreview: 10,
  },
]
